import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaWindowClose } from "react-icons/fa";
import { AiFillNotification } from "react-icons/ai";
import CommonModal from "./CommonModal";
import { byteCount, catchError, commonModalSetting } from "JS/common";
import { getNoticeDetail, noticeDelete } from "JS/API";

const NoticeDetail = ({ noticeId, setModal, setEditor }) => {
  const [idArray] = useState([noticeId] || []);
  const [info, setInfo] = useState({
    created_at: "",
    title: "",
    context: "",
    admin_name: "",
  });

  const [byte, setByte] = useState({
    title: 0,
    context: 0,
  });
  const [alert, setAlert] = useState("");
  const [alertBox, setAlertBox] = useState({
    mode: "",
    context: "",
    bool: false,
  });
  const navigate = useNavigate();
  let prevent = false;
  const domParser = new DOMParser();

  //= 공지사항 상세 내역 불러오기
  const getDetail = async () => {
    if (prevent) return;
    prevent = true;
    setTimeout(() => {
      prevent = false;
    }, 200);
    const result = await getNoticeDetail(idArray);
    if (typeof result === "object") {
      const { created_at, title, context, admin_name } = result?.data;
      setInfo({
        created_at: created_at,
        title: title,
        context: context,
        admin_name: admin_name,
      });
      const { data } = result;
      document.querySelector(".context").innerHTML = domParser.parseFromString(
        data?.context,
        "text/html"
      ).body.innerHTML;
    } else return await catchError(result, navigate, setAlertBox, setAlert);
  };
  //= 공지사항 삭제
  const delNotice = async () => {
    const requestData = {
      notice_ids: idArray,
    };

    const result = await noticeDelete(requestData);
    if (typeof result === "object") {
      setAlert("completeDelete");
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "정상적으로 삭제되었습니다."
      );
    } else return await catchError(result, navigate, setAlertBox, setAlert);
  };

  useEffect(() => {
    getDetail();
  }, []);

  useEffect(() => {
    byteCount(info.context, setInfo, setByte, "context", 3000);
  }, [info.context]);

  useEffect(() => {
    byteCount(info.title, setInfo, setByte, "title", 300);
  }, [info.title]);

  return (
    <>
      <div className="modal-background">
        <div className="modal-notice-container">
          <div className="modal-notice-header">
            <div className="modal-notice-title">
              <h3>공지사항</h3>
            </div>
            <div
              className="personnel-modal-close"
              onClick={() => setModal(false)}
            >
              <FaWindowClose />
            </div>
          </div>

          <div className="modal-notice-content">
            <div className="modal-notice-field">
              <div className="modal-notice-label">작성자</div>
              <div className="modal-notice-value">{info.admin_name}</div>
            </div>
            <div className="modal-notice-field">
              <div className="modal-notice-label">등록일자</div>
              <div className="modal-notice-value">
                {info.created_at?.replaceAll("T", " ") || ""}
              </div>
            </div>
          </div>

          <div className="modal-notice-answer-content">
            <div className="modal-notice-text">
              <div className="modal-notice-text-lable">
                <AiFillNotification />
                <h2>{info.title}</h2>
              </div>

              <div className="context"></div>
              <div className="modal-notice-footer">
                <div className="viewBytes">
                  <span>{byte.context} / 3000</span>
                </div>
                <div className="button-group">
                  <button
                    onClick={() => {
                      setEditor(true);
                      setModal(false);
                    }}
                  >
                    수정
                  </button>
                  <button
                    className="btn"
                    onClick={() => {
                      setAlert("deleteConfirm");
                      commonModalSetting(
                        setAlertBox,
                        true,
                        "confirm",
                        "해당 공지를 삭제하시겠습니까?"
                      );
                    }}
                  >
                    삭제
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alert === "deleteConfirm") delNotice();
            else if (alert === "completeDelete") setModal(false);
            else if (alert === "logout") navigate("/");
            else return;
          }}
        />
      )}
    </>
  );
};

export default NoticeDetail;
